import MuiButtonIcon from "./MuiButtonIcon";

export default MuiButtonIcon;
